module.exports = __webpack_public_path__ + "static/media/FO.80970352.svg";